import { Spinner } from "@cynthai/ui";
import { twMerge } from "tailwind-merge";

export default function LoadingScreen({
  isActive = true,
  noDim = false,
  className,
  text,
}: {
  readonly isActive?: boolean;
  readonly noDim?: boolean;
  readonly className?: string;
  readonly text?: string;
}) {
  return isActive ? (
    <div
      className={twMerge(
        `absolute inset-0 z-30 flex flex-col items-center justify-center`,
        !noDim && `bg-zinc-200/60`,
        className,
      )}
    >
      <Spinner size="lg" />
      {text && (
        <p className="text-text-primary mt-4 text-center text-sm">{text}</p>
      )}
    </div>
  ) : null;
}
